import { Injectable } from '@angular/core';
import { UserPermission } from '@core-lib/enums/user-permission.enum';
import { userHasPermission } from '@core-lib/functions/user.function';
import { selectCurrentCarpa, selectUserPermissions } from '@core-lib/store/user-store/selectors';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { filter, first } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class CarpaResolver {
	constructor(private store$: Store) {}

	resolve(): Observable<any> | Promise<boolean> | any {
		return combineLatest([this.store$.select(selectUserPermissions), this.store$.select(selectCurrentCarpa)]).pipe(
			filter(([selectUserPermissions, carpa]) => userHasPermission(selectUserPermissions, UserPermission.IsSuperAdmin) || !!carpa),
			first()
		);
	}
}
